export const isAlphaNumeric = (value: string) => {
    return /^[a-zA-Z0-9]+$/.test(value);
};

export const withFinalPeriod = (value: string) => {
    const trimmed = value.trimEnd();
    if (trimmed === "" || /[.!?…]$/.test(trimmed)) {
        return trimmed;
    }
    return `${trimmed}.`;
};
